import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import LoadingButton from "@mui/lab/LoadingButton";
import Typography from "@mui/material/Typography";
import Alert from "@mui/material/Alert";
import TextField from "@mui/material/TextField";
import LoginIllustration from "../../assets/login-illustration.png";
import LoginBackground from "../../assets/login-bg.png";
import * as colors from "@mui/material/colors";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import { verifyStart } from "../../store/auth/reducer";



export const Verify = ({ setActive, onClose, userEmail }) => {
  const dispatch = useDispatch();
  const { verifyLoading, verifyError, token } = useSelector(
    (state) => state.auth
  );
  // console.log(userEmail)
  const DEFAULT_VALUES = {
    email: userEmail,
    verificationToken: "",
  };
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    // defaultValues: DEFAULT_VALUES,
  });

  //   useEffect(() => {
  //     if (token) {
  //       reset(DEFAULT_VALUES);
  //       onClose();
  //     }
  //   }, [token]);

  const onSubmit = (values) =>

    dispatch(
      verifyStart({
        "email": userEmail,
        ...values,
      })
    );

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundImage: `url(${LoginBackground})`,
          backgroundRepeat: "no-repeat",
          height: "150px",
        }}
      >
        <img
          src={LoginIllustration}
          alt="Login Illustration"
          width="100px"
          height="100px"
        />
      </Box>

      <form onSubmit={handleSubmit(onSubmit)}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            marginTop: "50px",
          }}
        >
          <Typography variant="h4">Verify Code</Typography>
          {verifyError && <Alert severity="error">{verifyError}</Alert>}

          <Controller
            name="verificationToken"
            control={control}
            rules={{
              required: {
                value: true,
                message: "Code is requried",
              },
            }}
            render={({ field }) => (
              <TextField
                {...field}
                label="Enter Your Code"
                variant="standard"
                sx={{
                  width: "100%",
                }}
              // helperText={errors.email && errors.email.message}
              // error={!!errors.email}
              />
            )}
          />

          <LoadingButton
            color="primary"
            sx={{
              backgroundColor: "#04B2B2",
              color: "#FFFFFF",
              "&:hover": {
                backgroundColor: "#04B2B2",
              },
              marginTop: "10px",
            }}
            loading={verifyLoading}
            type="submit"
          >
            Verify
          </LoadingButton>



        </Box>
      </form>
    </Box>
  );
};
